import { render, staticRenderFns } from "./ExpertiseAreas.vue?vue&type=template&id=7e61ddde&scoped=true"
import script from "./ExpertiseAreas.vue?vue&type=script&lang=js"
export * from "./ExpertiseAreas.vue?vue&type=script&lang=js"
import style0 from "./ExpertiseAreas.vue?vue&type=style&index=0&id=7e61ddde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e61ddde",
  null
  
)

export default component.exports